// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-ynjtLstd-index-main_right_content-3fSoo","table":"components-swbl-ynjtLstd-index-table-2CHdh"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/ynjtLstd/index.css
// module id = 820
// module chunks = 0